import type { PageLoad } from './$types';
import { getLocale, i18nPath, locale2lang } from '$lib/i18n/routing';
import { routesPagename } from '$lib/services/urls/routesPagename';
import { enrichPoisStoreWithSelectedPoiData } from '$routes/(map)/loadPois';
import { redirect } from '@sveltejs/kit';
import { getPoisWithinRadiusStore } from '../loadPoisFromZoi';

export const load = (async (event) => {
	const { searchParams } = await event.parent();
	const { page, selectedPoi, zoi } = searchParams;

	if (!zoi) {
		redirect(302, i18nPath(`/routes${event.url.search}`, locale2lang(getLocale(event.url))));
	}

	const poisStoreWithoutSelectedPoiData = await getPoisWithinRadiusStore({
		event,
		page,
		searchParams,
		center: zoi.center,
		radius: zoi.radius * 1000,
	});

	const poisStore = await enrichPoisStoreWithSelectedPoiData(
		poisStoreWithoutSelectedPoiData,
		selectedPoi,
		event,
	);

	return {
		page,
		poisStore,
		mobileTopButtons: ['search', 'back-overview'],
		pagename: selectedPoi?.type
			? routesPagename[`${selectedPoi.type}_DATASHEET`]
			: undefined,
	};
}) satisfies PageLoad;
